module.exports = __webpack_public_path__ + "img/LiveWellnessText.4f5da6bb.png";